import React, { useState, useContext } from "react";
import { useFetch } from 'use-http';
import {
  useParams,
} from "react-router-dom";
import Alert from '@material-ui/core/Alert'
import { EditProductForm } from "./EditProductForm";
import { CircularProgress } from "@material-ui/core";
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  root: {
  },
}));

export function EditProductView({ onSave }) {
  const classes = useStyles();
  let { productId } = useParams();

  const { loading, error, data } = useFetch( `/products/${productId}`, {}, []);

  if (error) {
    return <Alert variant="outlined" severity="error">Something went wrong. Try refreshing.</Alert>
  }

  if (loading) {
    return <CircularProgress style={{ position: 'absolute', top: '48%', left: '48%' }} />;
  }

  return data && (
    <div className={classes.root}>
      <EditProductForm
        product={data}
        onSave={onSave}
      />
    </div>
  );
}
